{
  "title": "How to Review Student Eligibility",
  "description": "Review students' uploaded enrollment proofs — approve or reject — from the \"Eligibility review\" tab on the People & Roles page.",
  "headings": [
    "What You'll Accomplish",
    "Applies to",
    "Before You Start",
    "Where to Go",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "Once finished, that student's eligibility status updates to \"Verified\" or \"Rejected\" and is reflected immediately on their own screen.",
  "roleNote": "Competition admin",
  "prerequisites": [
    "The competition has \"Student Eligibility Verification\" turned on, and at least one student has uploaded a proof",
    "Your account has the eligibility-review permission for this competition (granted to competition admins by default; regular staff do not have it by default)"
  ],
  "pathLabel": "Organizer console → My Competitions → Operations → Eligibility Reviews (or: People & Roles → Eligibility review tab — the same workbench, two entry points)",
  "steps": [
    {
      "title": "1. Open the \"Eligibility review\" tab",
      "description": "From the competition's \"People & Roles\" page, if you have review permission you'll see \"Members\" and \"Eligibility review\" tabs at the top — click \"Eligibility review\". The top of the page shows three summary tiles: Verified, Pending, and Rejected."
    },
    {
      "title": "2. Filter the members you need to handle",
      "description": "Narrow the list with the status, team ID, and name/email/school filters. The filters are kept in sync with the URL, so you can share or return to the same filtered view later."
    },
    {
      "title": "3. Open the review drawer",
      "description": "Find the member you want to handle and click \"Review\" on their row. The drawer shows their name, team, school, department, and the proof file they uploaded."
    },
    {
      "title": "4. Preview or download the proof",
      "description": "From the drawer you can securely preview or download the member's original proof file to confirm it meets the requirements before deciding."
    },
    {
      "title": "5. Choose a decision and submit",
      "description": "Choose \"Verified\" or \"Rejected\". Choosing \"Rejected\" requires a free-text reason — you can't submit without one. Click \"Confirm review\" and the decision takes effect immediately. When you choose \"Rejected\" the screen tells you beforehand that the system will email the student with the reason you enter, so word it carefully; choosing \"Verified\" sends no email."
    }
  ],
  "afterward": [
    "That member's eligibility status immediately updates to \"Verified\" or \"Rejected\"",
    "If rejected, the student is emailed with your rejection reason and also sees it on their own \"Student Eligibility Verification\" page the next time they open it, and can re-upload on their own, so you don't need to notify them separately or take any further action; whether that email was sent or failed is recorded in the audit log",
    "The summary tiles at the top of the \"Eligibility review\" tab update to reflect the current verified/pending/rejected counts"
  ],
  "nextSteps": "To browse overall or historical eligibility data without taking a review action, go to the \"Eligibility Data\" page instead for a read-only summary and detail view.",
  "faq": [
    {
      "q": "Can staff review eligibility?",
      "a": "Not by default. The eligibility-review permission is granted to competition admins by default; the regular staff role does not have it, and the \"Eligibility review\" tab is not shown to them either."
    },
    {
      "q": "Do members who haven't uploaded anything show up in the list?",
      "a": "No. An eligibility record is only created after a member's first upload, so members who have never uploaded anything don't appear in this list at all — the summary section also notes that the \"not submitted\" count can't be computed here."
    },
    {
      "q": "Can I submit \"Rejected\" without a reason?",
      "a": "No. Choosing \"Rejected\" requires a reason. The \"Confirm review\" button stays disabled until you fill one in."
    }
  ]
}
